<svelte:options customElement="hb-checkout-shopping-cart" />

<script lang="ts">
  /**
   * Svelte Invoice WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */
  import type {
    IActionButton,
    IFilter,
    IRow,
    ITableHeader,
  } from "../table/types/webcomponent.type";

  import pkg from "../../../package.json";

  import "dayjs/locale/it";
  import type { IShoppingPayment } from "./types/webcomponent.type";
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import type { Component } from "./types/webcomponent.type";

  let {
    id = undefined,
    // style = undefined,
    completed = "no",
    payment = { countryCode: "IT", currencySymbol: "€", items: [] },
  }: Component = $props();
  const tableHeaders: ITableHeader[] = [
    {
      key: "name",
      label: "nome",
      nosort: true,
    },
    {
      key: "quantity",
      label: "n.",
      nosort: true,
    },
    {
      key: "total",
      label: "totale",
      nosort: true,
    },
  ];

  let tableRows: IRow[] = $state([]);
  let subTotal: number = $state(0);
  let taxTotal: number = $state(0);
  let total: number = $state(0);
  $effect(() => {
    // if (style) {
    // }

    if (!payment) {
      payment = { countryCode: "IT", currencySymbol: "€", items: [] };
    } else if (typeof payment === "string") {
      payment = JSON.parse(payment) || {};

      if (!payment.countryCode) payment.countryCode = "IT";
      if (!payment.currencySymbol) {
        switch (payment.countryCode) {
          case "IT":
            payment.currencySymbol = "€";
            break;
          case "EU":
            payment.currencySymbol = "€";
            break;
          case "US":
            payment.currencySymbol = "$";
            break;
        }
      }
    }

    if (payment?.items?.length) {
      tableRows = payment.items.map((m, i) => {
        const r: IRow = {
          _id: i.toString(),
          price:
            m.unitaryPrice.toString() +
            payment.currencySymbol +
            " / " +
            (m.unit ? m.unit : "unità"),
          name: m.name,
          quantity: m.quantity?.toString?.() || "1",
          subtotal:
            (m.unitaryPrice * (m.quantity || 1)).toString() +
            payment.currencySymbol,
          vat: `${(Math.round(m.taxPercentage * 0.01 * m.unitaryPrice * (m.quantity || 1) * 100) / 100).toString()} (${m.taxPercentage}%)`,
          total:
            (
              m.unitaryPrice * (m.quantity || 1) +
              Math.round(
                m.taxPercentage *
                  0.01 *
                  m.unitaryPrice *
                  (m.quantity || 1) *
                  100,
              ) /
                100
            ).toString() + payment.currencySymbol,
        };

        return r;
      });
    }
    subTotal = payment?.items
      ?.map((m) => m.unitaryPrice * (m.quantity || 1))
      .reduce((accumulator, a) => {
        return accumulator + a;
      }, 0);
    taxTotal = payment?.items
      ? Math.round(
          payment?.items
            .map(
              (m) =>
                m.unitaryPrice * (m.quantity || 1) * m.taxPercentage * 0.01,
            )
            .reduce((accumulator, a) => {
              return accumulator + a;
            }, 0) * 100,
        ) / 100
      : 0;

    total = subTotal + taxTotal + (payment.shipmentFee || 0);
  });
  // const component = get_current_component();
  // const svelteDispatch = createEventDispatcher();
  // function dispatch(name:string, detail:any) {
  // 	svelteDispatch(name, detail);
  // 	component.dispatchEvent && component.dispatchEvent(new CustomEvent(name, { detail }));
  // }

  addComponent({
    repoName: "@htmlbricks/hb-table",
    version: pkg.version,
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div id="page" class="container hb-cart-page">
  <h3 class="title is-4 is-flex is-align-items-center is-gap-2">
    <i class="bi bi-cart-fill hb-cart-title-icon" aria-hidden="true"></i>
    <span>Shopping Cart</span>
  </h3>
  <div class="columns my-5">
    <div class="column hb-cart-summary-column">
      <div class="hb-cart-summary-row">
        <span>SubTotale</span>
        <span class="has-text-weight-medium hb-cart-summary-value"
          >{subTotal}{payment.currencySymbol}</span
        >
      </div>
      <div class="hb-cart-summary-row">
        <span>Tasse</span>
        <span class="has-text-weight-medium hb-cart-summary-value"
          >{taxTotal}{payment.currencySymbol}</span
        >
      </div>
      <div class="hb-cart-summary-row">
        <span>Spedizione</span>
        <span class="has-text-weight-medium hb-cart-summary-value"
          >{payment?.shipmentFee
            ? payment?.shipmentFee + (payment?.currencySymbol || "")
            : "-"}</span
        >
      </div>
      <div class="hb-cart-summary-row hb-cart-summary-row--total">
        <span>Totale</span>
        <span class="hb-cart-summary-value">{total}{payment.currencySymbol}</span>
      </div>
    </div>
  </div>
  <div class="columns cart_divider">
    <div class="column">
      <hb-table
        disablepagination="yes"
        rows={JSON.stringify(tableRows)}
        headers={JSON.stringify(tableHeaders)}
      ></hb-table>
    </div>
  </div>
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
